var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "123px",
    height: "73px",
    viewBox: "0 0 123 73",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_TV_864206"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.354 0L122.354 65.7L62.8435 65.7L62.8435 68.2391L70.1435 68.2391L70.1435 71.413L52.5283 71.413L52.5283 68.2391L59.6696 68.2391L59.6696 65.7L0 65.7L0 0L122.354 0ZM119.18 3.17391L3.17391 3.17391L3.17391 62.5261L119.18 62.5261L119.18 3.17391Z",
    transform: "translate(0.6347826 0.7934783)",
    id: "Shape",
    fill: "#FFDA1A",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvIcon);
export default __webpack_public_path__ + "static/media/TV-icon.692f855786aab135a8bda1ff0daaaa94.svg";
export { ForwardRef as ReactComponent };